import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_menu_spread",
  "use": "rt-portal-rt_menu_spread-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-portal-rt_menu_spread\">\r\n<g>\r\n\t<path d=\"M132-120h824c19.8,0,36,16.2,36,36l0,0c0,19.8-16.2,36-36,36H132c-19.8,0-36-16.2-36-36l0,0C96-103.8,112.2-120,132-120z\" />\r\n\t<path d=\"M132,608h824c19.8,0,36,16.2,36,36l0,0c0,19.8-16.2,36-36,36H132c-19.8,0-36-16.2-36-36l0,0C96,624.2,112.2,608,132,608z\" />\r\n\t<path d=\"M132,244h506c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36H132c-19.8,0-36-16.2-36-36l0,0C96,260.2,112.2,244,132,244z\" />\r\n\t<path d=\"M977.3,311.1L816.1,441.8c-6.6,5.4-16.1,0.4-16.1-8.4V126.6c0-8.8,9.5-13.8,16.1-8.4l161.1,130.7\r\n\t\tC996.9,264.8,996.9,295.2,977.3,311.1z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_menu_spread.svg
// module id = 700
// module chunks = 99